'use strict';

module.exports = require('./slider');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_react-slick@0.16.0@react-slick/lib/index.js
// module id = 274
// module chunks = 0 1